import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../../Components/Loader/Loader';
import { toast } from 'react-toastify';
import { useAuthContext } from '../../hooks/UseAuthContext';
import api from '../../api';

function SelectedNews() {
    const [news, setNews] = useState(null);
    const [isNews,setIsNews]=useState(true)
    const [platform, setPlatform] = useState('youtube');
    const [duration, setDuration] = useState('');
    const [audience, setAudience] = useState('');
    const [emotion, setEmotion] = useState('');
    const [optionalPrompt, setOptionalPrompt] = useState('');
    const [vidMetadata,setVidMetaData]=useState(false)
    const [loading,setLoading]=useState(true)
    const { newsId } = useParams();
    const navigate = useNavigate();
    const {user}=useAuthContext()

    const goBack=()=>{
       navigate(-1)

    }

    useEffect(() => {
        api.get(`/news/${newsId}`,{
          headers:{
            Authorization:`Bearer ${user.token}`
          }
        })
            .then(response => {
                console.log(response.data);
    
                if(response.data.composed){
                 toast.error("Already Composed")
                 navigate('/')
                }else{
                  setLoading(false)

                  setNews(response.data);

                }
               
            })
            .catch(error =>{
              console.error("Error fetching news", error)
              setLoading(false)
            });
    }, [newsId]);

    const scriptSelected = (article) => {
        console.log(article);
        setLoading(true)
        if(!platform){
            toast.error("Choose a platform")
            setLoading(false)
        }
        if(!duration){
            setLoading(false)
            toast.error("Choose an approximate video duration")
        }

        api.post(`/update-news-compose`,{
          newsId:newsId
         }, {
          headers:{
            Authorization:`Bearer ${user.token}`,
            'Content-Type': 'application/json',
          }
        }).then(response=>{
          console.log(response.data)
        }).catch(error=>{
          console.log(error)
        })
        
        api.post(`/generate-video`, {
            description: article.text,
            duration:duration,
            emotion:emotion,
            optionalPrompt:optionalPrompt

        }, {
          headers:{
            Authorization:`Bearer ${user.token}`,
            'Content-Type': 'application/json',
          }
        }).then(response => {
            console.log("this is response of gpt",response.data);
            setLoading(false)
            navigate(`/compose/${response.data._id}`);
        }).catch(error => {
            setLoading(false)
            console.error("Error generating video", error);
        });
    };

    const formatDateTime = (isoString) => {
        console.log(isoString)
        if (!isoString) return { day: "", month: "", time: "" };
        const date = new Date(isoString);
        const day = date.getDate().toString().padStart(2, "0"); // 08
        const month = date.toLocaleString("en-US", { month: "short" }); // Feb
        const time = date.toLocaleString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
        console.log(day,month,time)
        return { day, month, time };
    };

   

    return (
        <div >

            <div className="selected-news">

               {
                isNews&&(
                    <div className="news-data">
                
               {news ? (
                <div className="single-news-data">
                      <h3>{news.title}</h3>
                      <div className="source-data-date">
                      <p>{news.source}</p>
                    
                        <div className='date'>
                        <span className="day">{formatDateTime(news.publish_date?.$date).day}</span>
                        <span className="month">{formatDateTime(news.publish_date?.$date).month}</span>
                        </div>
                    </div>
                  
                      
                      <textarea name="news-script" id="news-script"
                      value={news.text}
                      
                      
                      />
                 
                    <div className="news-navigate">
                <button onClick={goBack}>Back</button>
                <button onClick={()=>{
                    setIsNews(false)
                    setVidMetaData(true)
                }}>Continue</button>
            </div>
                </div>
            ) : (
            <div><Loader /></div>
            )}

           
               </div>
                )
               }

               {
                vidMetadata&&(
                    <div className="video-meta-data">
                    <div className="section">
                      <h4>Duration</h4>
                      <div className="options">
                        <button
                          className={duration === '1' ? 'active' : ''}
                          onClick={() => setDuration('1')}
                        >
                          1.0 Minutes
                        </button>
                        <button
                          className={duration === '4' ? 'active' : ''}
                          onClick={() => setDuration('4')}
                        >
                          5.0 Minutes
                        </button>
                        <button
                          className={duration === '10' ? 'active' : ''}
                          onClick={() => setDuration('10')}
                        >
                          10.0 Minutes
                        </button>
                        <button
                          className={duration === '15' ? 'active' : ''}
                          onClick={() => setDuration('15')}
                        >
                          15.0 Minutes
                        </button>
                        <button
                          className={duration === '20' ? 'active' : ''}
                          onClick={() => setDuration('20')}
                        >
                          20.0 Minutes
                        </button>
                      </div>
                    </div>
              
                    {/* <div className="section">
                      <h4>Audiences</h4>
                      <div className="options">
                        <button
                          className={audience === 'Business Owners' ? 'active' : ''}
                          onClick={() => setAudience('Business Owners')}
                        >
                          Business Owners
                        </button>
                        <button
                          className={audience === 'Travel Enthusiasts' ? 'active' : ''}
                          onClick={() => setAudience('Travel Enthusiasts')}
                        >
                          Travel Enthusiasts
                        </button>
                        <button
                          className={audience === 'General Public' ? 'active' : ''}
                          onClick={() => setAudience('General Public')}
                        >
                          General Public
                        </button>
                      </div>
                    </div> */}
              
                    <div className="section">
                      <h4>Platform</h4>
                      <div className="options">
                        <button
                          className={platform === 'youtube' ? 'active' : ''}
                          onClick={() => setPlatform('youtube')}
                        >
                          YouTube
                        </button>
                        <button
                          className={platform === 'youtube_shorts' ? 'active' : ''}
                          onClick={() => setPlatform('youtube_shorts')}
                        >
                          YouTube Shorts
                        </button>
                        <button
                          className={platform === 'tiktok' ? 'active' : ''}
                          onClick={() => setPlatform('tiktok')}
                        >
                          TikTok
                        </button>
                        <button
                          className={platform === 'facebook' ? 'active' : ''}
                          onClick={() => setPlatform('facebook')}
                        >
                          Facebook
                        </button>
                      </div>
                    </div>
              
                    <div className="section">
                      <h4>Focus Emotion</h4>
                      <input
                        type="text"
                        placeholder="Enter Script Emotion"
                        value={emotion}
                        onChange={(e) => setEmotion(e.target.value)}
                      />
                    </div>
              
                    <div className="section">
                      <h4>Optional Prompt</h4>
                      <input
                        type="text"
                        placeholder="Optional Prompt"
                        value={optionalPrompt}
                        onChange={(e) => setOptionalPrompt(e.target.value)}
                      />
                    </div>
              
                    <div className="meta-data-buttons">
                      <button className="edit-prompt" onClick={()=>{
                        setVidMetaData(false)
                        setIsNews(true)
                      }}>Edit Prompt</button>
                      <button className="continue" onClick={() => scriptSelected(news)}>Generate</button>
                    </div>
                  </div>
                )
               }

        



            </div>
            

            {
               loading&&(
                <Loader />
               )
            }

            
        </div>
    );
}

export default SelectedNews;
